'use strict';
(function() {
  /* eslint no-var: 0 */
  function canPass(raw, wl) {
    if (!raw || !wl) return false;
    for (var i = 0; i < wl.length; i++) {
      if (raw.indexOf(wl[i]) !== -1) return true;
    }
    return false;
  }

  var ua = window.navigator.userAgent.toLowerCase();

  var dprWL = [ 'ucbrowser' ];
  var dpr = canPass(ua, dprWL) ? Math.min(2, window.devicePixelRatio) : 1;

  var fontWL = [ 'ucbrowser', 'fb' ];
  var fontResize = canPass(ua, fontWL);

  var UI = {
    VOH: 'width',
    DsgSize: 640,
    root: document.documentElement,
    needPut: false,
    ucHole: 1,
    resolution: dpr,
    rem: 1000,
    monitoring: false,
    shouldFill: fontResize,
    viewport: {
      width: 'device-width',
      'initial-scale': 1,
      'user-scalable': 'no',
      'viewport-fit': 'cover',
    },
  };

  UI.init = function(opts) {
    opts = opts || {};
    this.VOH = opts.VOH || this.VOH;
    this.DsgSize = opts.DsgSize || this.DsgSize;
    this.rem = opts.rem || this.rem;
    this.resolution = opts.resolution || this.resolution;
    this.meta = this.meta || document.querySelector('meta[name="viewport"]');
    this.viewport = opts.viewport || this.viewport;
    this._putMeta();
    this.suit();
    this._ears();
  };
  UI._putMeta = function() {
    if (!this.meta) {
      this.meta = document.createElement('meta');
      this.meta.setAttribute('name', 'viewport');
      this.needPut = true;
    }
    var ratio = 1 / this.resolution;

    this.viewport['initial-scale'] = ratio;

    var valueStr = [];
    for (var attr in this.viewport) {
      valueStr.push(attr + '=' + this.viewport[attr]);
    }

    this.meta.setAttribute('content', valueStr.join(', '));
    if (this.needPut) {
      document.head.appendChild(this.meta);
      this.needPut = false;
    }
  };
  UI._ears = function() {
    if (this.monitoring) return;
    var This = this;
    window.addEventListener('resize', function() {
      This.suit();
    }, false);
    document.addEventListener('DOMContentLoaded', function() {
      This.shouldFill && This._fillHole();
    });
    setTimeout(function() {
      This.suit();
    }, 100);
    this.monitoring = true;
  };
  UI._fillHole = function() {
    var dom = document.createElement('div'),
      sPX = 100,
      tPX = 100;
    dom.style.fontSize = sPX + 'px';
    document.body.appendChild(dom);
    tPX = parseInt(window.getComputedStyle(dom, null).getPropertyValue('font-size'), 10) || tPX;

    this.ucHole = sPX / tPX;
    this.suit();
    setTimeout(function() {
      document.body.removeChild(dom);
    }, 100);
  };
  UI.suit = function() {
    var nowSize = this.VOH === 'width' ? document.documentElement.offsetWidth : document.documentElement.offsetHeight;
    this.sPPR = this.rem * nowSize / this.DsgSize;
    this.curPPR = this.ucHole * this.sPPR;
    this.root.style.fontSize = this.curPPR + 'px';
  };
  /* eslint no-bitwise: 0*/
  UI.RTP = function(rem, bool) {
    return (bool ? rem * this.curPPR : rem * this.sPPR) >> 0;
  };
  UI.PTR = function(px) {
    return px / this.curPPR;
  };

  window.JC = window.JC || {};
  window.JC.UI = UI;
})();
window.JC.UI.init();
